import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Shape from '@active-channel/images/badges/badge-shapes/badge-shape-text.svg';
import './styles/styles.scss';

const BadgeText = (props) => {
  const { badgeText } = props;

  const [badgeTextImage, setBadgeTextImage] = useState('');

  const svg = {
    recommended: 'recommended.svg',
    onlyatbookspot: 'only-at-bookspot.svg',
    onlytoday: 'only-today.svg',
    orderandwin: 'order-and-win.svg',
    dailydeal: 'daily-deal.svg',
    exclusive: 'exclusive.svg',
    hooray: 'hooray.svg',
    meetandgreet: 'meet-and-greet.svg',
    giftitem: 'giftitem.svg',
    new: 'new.svg',
    sneakpreview: 'sneak-preview.svg',
    voteandwin: 'vote-and-win.svg',
    tip: 'tip.svg',
    win: 'win.svg',
    contest: 'contest.svg',
    enbookofthemonth: 'en-book-of-the-month.svg',
    nlbookofthemonth: 'nl-book-of-the-month.svg',
    top10: 'top-10.svg',
    signed: 'signed.svg',
    preorder: 'preorder.svg',
  };

  const badgeRef = useRef();
  const importBadge = async () => {
    const badgeTextFilename = svg[badgeText];
    const badgeTextFile = await import(`@active-channel/images/badges/badge-texts/${badgeTextFilename}`);
    setBadgeTextImage(badgeTextFile.default);
  };

  const generateSource = (svg) => {
    if (!svg) {
      return '';
    }
    const xml = (new XMLSerializer).serializeToString(svg);
    return `data:image/svg+xml;base64,${btoa(xml)}`;
  };

  useEffect(() => {
    importBadge();
  }, []);

  const [source, setSource] = useState('');
  useEffect(() => {
    const node = badgeRef.current;
    const src = generateSource(node.firstChild);
    setSource(src);
  }, [badgeTextImage]);

  const badgeClass = badgeText ? `badge-text-${badgeText}` : '';

  return (
    <div className={`badge-custom badge-text ${badgeClass}`}>
      <Shape className="badge-shape" />
      <div style={{ display: 'none' }} ref={badgeRef}>{badgeTextImage}</div>
      <img src={source} alt={badgeText} className="badge-content"/>
    </div>
  );
};

BadgeText.propTypes = {
  badgeText: PropTypes.string,
};

export default BadgeText;
